<template>
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clip-rule="evenodd"
      d="M21 6.53867C21 8.49302 19.4157 10.0773 17.4613 10.0773C16.4464 10.0773 15.5313 9.65005 14.886 8.96555L12.7333 10.3847C12.9062 10.8914 13 11.4347 13 12C13 12.7199 12.8479 13.4043 12.574 14.0227L14.7128 15.4843C15.3616 14.6853 16.3519 14.1747 17.4613 14.1747C19.4157 14.1747 21 15.759 21 17.7133C21 19.6677 19.4157 21.252 17.4613 21.252C15.507 21.252 13.9227 19.6677 13.9227 17.7133C13.9227 17.6001 13.928 17.488 13.9384 17.3775L11.4144 15.6527C10.5207 16.4884 9.32011 17 8 17C5.23858 17 3 14.7614 3 12C3 9.23858 5.23858 7 8 7C9.47659 7 10.8037 7.64007 11.719 8.65788L13.9785 7.16829C13.9418 6.96396 13.9227 6.75355 13.9227 6.53867C13.9227 4.58432 15.507 3 17.4613 3C19.4157 3 21 4.58432 21 6.53867ZM19 6.53867C19 7.38845 18.3111 8.07734 17.4613 8.07734C16.6116 8.07734 15.9227 7.38845 15.9227 6.53867C15.9227 5.68888 16.6116 5 17.4613 5C18.3111 5 19 5.68888 19 6.53867ZM8 15C9.65685 15 11 13.6569 11 12C11 10.3431 9.65685 9 8 9C6.34315 9 5 10.3431 5 12C5 13.6569 6.34315 15 8 15ZM19 17.7133C19 18.5631 18.3111 19.252 17.4613 19.252C16.6116 19.252 15.9227 18.5631 15.9227 17.7133C15.9227 16.8636 16.6116 16.1747 17.4613 16.1747C18.3111 16.1747 19 16.8636 19 17.7133Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
